import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Link, Routes, Redirect } from "react-router-dom";

import "./bs.scss";
import "./app.scss";

import "bootstrap/js/dist/modal";

import CookieAccept from "./global/cookie-accept.js";

import Header from "./global/header.js";

import Page from "./pages/page.js";

import Home from "./pages/home.js";
import Aktuelles from "./pages/aktuelles.js";
import UeberUns from "./pages/ueber-mich.js";
import Ausbildung from "./pages/ausbildung.js";
import Hypnopics from "./pages/hypnopics.js";
import Newsletter, { NewsletterModal } from "./pages/newsleter.js";
import Kontakt from "./pages/kontakt.js";
import Impressum from "./pages/impressum.js";
import HypnopicsNewsletter from "./pages/hypnopics-newsletter.js";

import Footer from "./global/footer.js";

import neuronen1 from "./img/neuronen1.jpg";
import garten3 from "./img/garten3.jpg";

const pages = [
  { component: Home, path: "/", name: "Home" },
  { component: Aktuelles, path: "/aktuelles", name: "Aktuelles", topic: <h1>Aktuelles</h1> },
  { component: UeberUns, path: "/ueber-mich", name: "Über Mich", topic: <h1>Über Mich</h1> },
  { component: Ausbildung, path: "/ausbildung", name: "Ausbildung", backgroundImageUrl: neuronen1, topic: <h1>Ausbildung Zum Coach</h1> },
  { component: Hypnopics, path: "/hypnopics", name: "Hypnopics ©", backgroundImageUrl: garten3, topic: <h1>Hypnopics ©</h1> },
  { component: Newsletter, path: "/newsletter", name: "Newsletter", topic: <h1>Gehirnpfade Newsletter</h1> },
  { component: Kontakt, path: "/kontakt", name: "Kontakt", topic: <h2>Kontaktieren Sie mich</h2> },
  { component: Impressum, path: "/impressum", name: "Impressum", topic: <h1>Impressum</h1> },
  { component: HypnopicsNewsletter, path: "/hypnopics-newsletter-anmeldung", name: "Informationen zu den HypnoPics ©", topic: <></> },
];

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Router>
        <React.Fragment>
          <CookieAccept />
          <Header pages={pages.filter((page) => page.path !== "/impressum" && page.path !== "/hypnopics-newsletter-anmeldung")} />
          <NewsletterModal />
          <Routes>
            {pages.map(function (page, index) {
              return (
                <Route
                  path={page.path}
                  element={
                    <Page backgroundImageUrl={page.backgroundImageUrl} topic={page.topic}>
                      <page.component />
                    </Page>
                  }
                  key={index}
                />
              );
            })}
            <Route path='*' element={
              <Page>
                <Home />
              </Page>
            } />
          </Routes>
          <Footer />
        </React.Fragment>
      </Router>
    );
  }
}

export default App;
